import styled, { css } from 'styled-components'
import Text from '../Text'
import { ThemeColor } from 'utils/colors'
import { FontWeightType } from 'utils/fonts'
import { FontProps } from 'types/styled'

export type NavigationTabVariant = 'default' | 'navbar' | 'simple' | 'collapsible' | 'addon'

type VariantConfig = {
  containerPadding: string
  labelPadding: string
  labelFontSize?: FontProps['size']
  labelFontWeight: FontWeightType
  labelActiveColor: ThemeColor
  labelInactiveColor: ThemeColor
  inactiveBorderColor?: ThemeColor
  borderWidth: string
}

const defaultConfig: VariantConfig = {
  containerPadding: '0',
  labelPadding: '12px 20px',
  labelFontSize: 14,
  labelFontWeight: 'bold',
  labelActiveColor: 'blue1',
  labelInactiveColor: 'disabledText',
  borderWidth: '4px',
} as const

export const VARIANT_STYLES: Record<NavigationTabVariant, VariantConfig> = {
  default: defaultConfig,
  navbar: {
    ...defaultConfig,
    labelPadding: '20px 24px',
  },
  simple: {
    ...defaultConfig,
    labelActiveColor: 'defaultText',
  },
  collapsible: {
    ...defaultConfig,
    labelFontSize: 16,
  },
  addon: {
    ...defaultConfig,
    labelFontWeight: 'medium',
  },
}

export const TabContainer = styled.div<{ containerPadding: string; fullwidth?: boolean }>`
  cursor: pointer;
  padding: ${(p) => p.containerPadding};
  text-align: center;
  width: ${(p) => (p.fullwidth ? '100%' : 'fit-content')};
`

export const TabContent = styled.div<{
  active?: boolean
  borderColor: string
  borderWidth: string
  labelPadding: string
  activeColor?: ThemeColor
}>`
  position: relative;
  display: flex;
  justify-content: center;
  gap: 0.5rem;

  ${(p) =>
    css`
      border-bottom: solid;
      border-color: ${p.borderColor};
      border-width: ${p.borderWidth};
      padding: ${p.labelPadding};
    `};

  ${(p) =>
    !p.active &&
    css`
      :hover [data-navigation-tab='label'] {
        color: ${p.theme.colors.gray7};
      }
    `}
`

export const SuperScript = styled(Text)<{ superScriptColor?: ThemeColor }>`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(calc(100% + 4px), -50%);
  ${(p) => p.theme.font({ size: 10, weight: 'bold', color: p.superScriptColor ?? 'disabledText' })};
  white-space: nowrap;
`
